import { useState } from 'react';

import { useMutation } from '@tanstack/react-query';
import { Trash2Icon, TriangleAlertIcon } from 'lucide-react';
import { toast } from 'sonner';

import { msCatalystApi } from '../../../../services/api/ms-catalyst-api.js';
import { queryClient } from '../../../../services/query/client.js';

import Loading from '../../../feedback/loading.jsx';
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '../../../ui/alert-dialog.jsx';
import { Button } from '../../../ui/button.jsx';
import { Checkbox } from '../../../ui/checkbox.jsx';

export const DialogVoidInvoice = ({ invoiceId }) => {
  const [open, setOpen] = useState(false);
  const [checked, setChecked] = useState(false);

  const mutationVoidInvoice = useMutation({
    mutationFn: async (data) => {
      await msCatalystApi.put(`/customers/invoices/void/${invoiceId}`);

      return true;
    },
    onSuccess: () => {
      toast.success('Fatura anulada com sucesso');

      queryClient.invalidateQueries({
        queryKey: ['invoices_customer_activeCampaign'],
      });
    },
    onError: () => {
      toast.error('Ocorreu um erro ao anular a sua fatura', {
        description: 'Por favor tente novamente mais tarde',
      });
    },
    onSettled: () => {
      setOpen(false);
    },
  });

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogTrigger asChild>
        <Button
          variant="portal-destructive"
          className="mx-auto mt-3.5 flex flex-row rounded-full text-sm"
        >
          <Trash2Icon className="size-3" />
          Anular fatura
        </Button>
      </AlertDialogTrigger>

      <AlertDialogContent>
        {mutationVoidInvoice.isPending ||
        mutationVoidInvoice.isSuccess ||
        mutationVoidInvoice.isError ? (
          <div className="flex w-full justify-center">
            <Loading message="A anular fatura" />
          </div>
        ) : (
          <>
            <AlertDialogHeader>
              <TriangleAlertIcon className="mx-auto size-32 text-portal-destructive" />
              <AlertDialogTitle className="text-xl text-red-500">
                Tem a certeza?
              </AlertDialogTitle>
              <AlertDialogDescription>
                <span>
                  <span>
                    A sua fatura será anulada permanentemente do sistema.
                  </span>
                </span>
              </AlertDialogDescription>
              <AlertDialogDescription className="font-bold text-red-500">
                ESTA AÇÃO É IRREVERSÍVEL.
              </AlertDialogDescription>
            </AlertDialogHeader>
            <div className="flex flex-row items-start space-x-2">
              <Checkbox
                className="mt-0.5"
                checked={checked}
                onCheckedChange={setChecked}
              />
              <AlertDialogDescription className="space-y-0 text-sm">
                Eu concordo que esta ação tem consequências irreversíveis e que
                mesmo assim quero realizá-la.
              </AlertDialogDescription>
            </div>
            <AlertDialogFooter>
              <Button
                disabled={!checked}
                onClick={async (event) => {
                  event.preventDefault();

                  mutationVoidInvoice.mutate();
                }}
              >
                Anular
              </Button>

              <AlertDialogCancel>Cancelar</AlertDialogCancel>
            </AlertDialogFooter>
          </>
        )}
      </AlertDialogContent>
    </AlertDialog>
  );
};
